import $ from 'jquery'

export const TextAnalyticsCategoryComponent = (() => {
	const init = () => {
		if ($.nette && !$.nette.ext('ta-category-loading')) {
			$.nette.ext('ta-category-loading', {
				start: (xhr: any, settings: any) => {
					if (settings.nette && settings.nette.el) {
						const $el = $(settings.nette.el)
						if ($el.hasClass('js-ta-loading-button')) {
							$el.addClass('loading')
							$el.closest('.ta-category-container').find('.ta-category-overlay').addClass('visible')
						}
					}
				},
				complete: (payload: any, status: any, xhr: any, settings: any) => {
					if (settings.nette && settings.nette.el) {
						const $el = $(settings.nette.el)
						$el.removeClass('loading')
						$el.closest('.ta-category-container').find('.ta-category-overlay').removeClass('visible')
					} else {
						$('.js-ta-loading-button').removeClass('loading')
						$('.ta-category-overlay').removeClass('visible')
					}
				},
			})
		}

		$(document)
			.off('click.ta-category')
			.on('click.ta-category', '.js-ta-loading-button', function (e) {
				const $el = $(this)

				if (($el.hasClass('ajax') || $el.closest('form').hasClass('ajax')) && !$el.hasClass('loading')) {
					$el.addClass('loading')
					$el.closest('.ta-category-container').find('.ta-category-overlay').addClass('visible')
				}
			})

		$(document)
			.off('keydown.ta-category')
			.on('keydown.ta-category', 'form.ajax', function (e) {
				if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey && !e.metaKey) {
					const $form = $(this)
					const $submitBtn = $form.find('.js-ta-loading-button[type="submit"]')
					if ($submitBtn.length > 0 && !$submitBtn.hasClass('loading')) {
						$submitBtn.addClass('loading')
						$submitBtn.closest('.ta-category-container').find('.ta-category-overlay').addClass('visible')
					}
				}
			})
	}

	return {
		init,
	}
})()
